module.exports = __webpack_public_path__ + "img/ScheduleCanparPickup.75c3782f.svg";